import styled from 'styled-components';
import { EDITOR_TOPBAR_HEIGHT } from '../editor/editorLayout.constants';
import { DOCK_WIDTH_OPEN } from '../editor/dock/ProcessSidePanel.styled';

export const RunDockRoot = styled.div`
  position: fixed;
  top: ${EDITOR_TOPBAR_HEIGHT}px;
  right: 0;
  bottom: 0;
  width: ${DOCK_WIDTH_OPEN}px;
  z-index: 12;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors?.surface ?? '#13131B'};
  border-left: 1px solid
    ${({ theme }) => theme.colors?.outlineVariant ?? '#464555'};
  pointer-events: auto;
`;

export const RunDockBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  scrollbar-gutter: stable;

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) =>
      theme.colors?.surfaceContainerHigh ?? '#292932'};
    border-radius: 100px;
    border: 2px solid transparent;
    background-clip: padding-box;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) =>
      theme.colors?.surfaceContainerHighest ?? '#34343D'};
    background-clip: padding-box;
    border: 2px solid transparent;
  }
`;

export const FloatingStatusDot = styled.span<{ $color: string }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${(p) => p.$color};
  flex-shrink: 0;
`;

export const FloatingStatusLabel = styled.span<{ $color: string }>`
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => p.$color};
  white-space: nowrap;
`;

export const FloatingMeta = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors?.onSurfaceVariant ?? '#C7C4D7'};
  white-space: nowrap;
`;
